export default __webpack_public_path__ + "static/woman-ed8ff56906ae4bd321a2bee4d5f9818b.png";